export enum ECameraType {
  FEATURE_EXT = 'FEATURE-EXT',
  FEATURE_INT = 'FEATURE-INT',
  FEATURE_RETAILER = 'FEATURE-RETAILER',
  EXT_360 = 'EXT 360',
  EXT_STUDIO_360 = 'EXT_STUDIO_360',
  EXT_ENV_360 = 'EXT_ENV_360',
  INT_360 = 'INT 360', // INTERIOR_360
  INT_PANO = 'CENTERPANO',
  INT_PANO_STUDIO_SEATS_UP = 'CENTERPANO_STUDIO_SEATS_UP',
  INT_PANO_STUDIO_SEATS_DOWN = 'CENTERPANO_STUDIO_SEATS_DOWN',
  INT_PANO_ENV_SEATS_UP = 'CENTERPANO_ENV_SEATS_UP',
  INT_PANO_ENV_SEATS_DOWN = 'CENTERPANO_ENV_SEATS_DOWN',
}

export enum EIrisCameraType {
  FEATURE_EXT = 'EF',
  FEATURE_INT = 'IF',
  EXT_360 = 'E',
  INT_360 = 'I',
  INT_PANO = 'centerpano',
}
